class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.modalContentContainer = this.querySelector('[data-modal-content-container]');
    this.modalContentTemplate = this.querySelector('template[data-modal-content-template]');
    this.boundClose = this.close.bind(this);

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.bindCloseButton();

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  ensureModalContent() {
    if (!this.modalContentContainer || this.modalContentContainer.dataset.modalContentLoaded === 'true') return;

    if (this.modalContentTemplate) {
      this.modalContentContainer.appendChild(this.modalContentTemplate.content.cloneNode(true));
    }

    this.modalContentContainer.hidden = false;
    this.modalContentContainer.removeAttribute('hidden');
    this.modalContentContainer.dataset.modalContentLoaded = 'true';
    this.bindCloseButton();
  }

  bindCloseButton() {
    const closeButton = this.querySelector('button[type="button"]');
    if (!closeButton || closeButton.dataset.detailsModalBound === 'true') return;

    closeButton.dataset.detailsModalBound = 'true';
    closeButton.addEventListener('click', this.boundClose);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.ensureModalContent();
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])') || this.summaryToggle
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
